module.exports = __webpack_public_path__ + "static/media/technical-min.e486da2e.jpg";